export const dashboardPl = {
  // wspólne — DashboardNav
  'dashboard.nav.ariaLabel': 'Sekcje pulpitu nawigacyjnego',
  'dashboard.nav.overview': 'Przegląd',
  'dashboard.nav.avatar': 'Awatar',
  'dashboard.nav.coins': 'Monety',
  'dashboard.nav.contributions': 'Wkład',

  // wspólne — StatusBadge (status wkładu)
  'dashboard.status.draft': 'Szkic',
  'dashboard.status.submitted': 'Wysłane',
  'dashboard.status.communityReview': 'Recenzja społeczności',
  'dashboard.status.officialReview': 'Recenzja oficjalna',
  'dashboard.status.approved': 'Zatwierdzone',
  'dashboard.status.rejected': 'Odrzucone',
  'dashboard.status.unknown': 'nieznany',

  // wspólne — ClaimStatusBadge
  'dashboard.claimStatus.pending': 'oczekuje',
  'dashboard.claimStatus.approved': 'zatwierdzone',
  'dashboard.claimStatus.rejected': 'odrzucone',

  // DashboardPage
  'dashboard.seo.title': 'Mój Grymwyrd',
  'dashboard.seo.description': 'Twoje monety, roszczenia, wkład i postacie w wiecznym zmroku.',
  'dashboard.displayNameFallback': 'Wędrowiec',
  'dashboard.welcomeBack': 'Witaj ponownie',
  'dashboard.editAvatar': 'Edytuj awatar',
  'dashboard.loading': 'Zbieramy twoją legendę…',
  'dashboard.avatarAlt': 'Portret {name}',
  'dashboard.offlineNotice':
    'Dane profilu na żywo są niedostępne — wyświetlamy ostatnią znaną sesję i przykładową zawartość.',

  // DashboardPage — karta Monet
  'dashboard.coins.title': 'Monety grobów',
  'dashboard.coins.viewAll': 'Pokaż wszystkie',
  'dashboard.coins.unit': 'monety',
  'dashboard.coins.noActivity': 'Brak ruchu monet.',
  'dashboard.coins.fullHistory': 'Pełna historia i zakup monet',

  // DashboardPage — karta Wkładu
  'dashboard.contributions.title': 'Wkład',
  'dashboard.contributions.manage': 'Zarządzaj',
  'dashboard.contributions.empty': 'Brak wkładu — napisz swój pierwszy.',

  // DashboardPage — karta Roszczeń
  'dashboard.claims.title': 'Zdobyte tereny',
  'dashboard.claims.empty': 'Nie posiadasz jeszcze terenu w Grymwyrdzie.',
  'dashboard.claims.kindClaimed': '{kind} · zdobyte {date}',

  // DashboardPage — karta Postaci
  'dashboard.characters.title': 'Postacie',
  'dashboard.characters.empty': 'Żadne dusze nie są związane z twoim imieniem.',
  'dashboard.characters.level': 'Poz. {level}',
  'dashboard.characters.unknown': 'Nieznany',

  // AvatarEditorPage
  'dashboard.avatarEditor.seo.title': 'Edytor Awatara',
  'dashboard.avatarEditor.seo.description': 'Kształtuj twarz, którą pokazujesz światu Grymwyrd.',
  'dashboard.avatarEditor.heading': 'Edytor Awatara',
  'dashboard.avatarEditor.errorNotImage': 'Ten plik nie jest obrazem.',
  'dashboard.avatarEditor.errorNameRequired': 'Imię jest wymagane, nawet w ciemności.',
  'dashboard.avatarEditor.portrait': 'Portret',
  'dashboard.avatarEditor.portraitPreview': 'Podgląd portretu',
  'dashboard.avatarEditor.avatarPreviewAlt': 'Podgląd awatara',
  'dashboard.avatarEditor.zoom': 'Przybliżenie',
  'dashboard.avatarEditor.zoomAria': 'Przybliż portret',
  'dashboard.avatarEditor.panHorizontal': 'Przesuń portret poziomo',
  'dashboard.avatarEditor.panVertical': 'Przesuń portret pionowo',
  'dashboard.avatarEditor.uploadAria': 'Prześlij obraz portretu',
  'dashboard.avatarEditor.changeImage': 'Zmień obraz',
  'dashboard.avatarEditor.uploadImage': 'Prześlij obraz',
  'dashboard.avatarEditor.identity': 'Tożsamość',
  'dashboard.avatarEditor.displayName': 'Wyświetlana nazwa',
  'dashboard.avatarEditor.backstory': 'Historia postaci',
  'dashboard.avatarEditor.backstoryPlaceholder': 'Skąd przybyłeś i jaki mroczny los cię czeka?',
  'dashboard.avatarEditor.publicProfile': 'Profil publiczny',
  'dashboard.avatarEditor.publicVisible': 'Widoczny w Sali legend.',
  'dashboard.avatarEditor.publicHidden': 'Ukryty przed innymi wędrowcami.',
  'dashboard.avatarEditor.saving': 'Zapisywanie…',
  'dashboard.avatarEditor.saveChanges': 'Zapisz zmiany',
  'dashboard.avatarEditor.saved': 'Zapisano',

  // CoinHistoryPage
  'dashboard.coinHistory.checkoutUnavailable': 'Kasa nie jest jeszcze dostępna — kasy pozostają zamknięte.',
  'dashboard.coinHistory.notEnoughCoins': 'Niewystarczająco monet na to.',
  'dashboard.coinHistory.reasonWorldClaim': 'Zdobycie terenu',
  'dashboard.coinHistory.reasonCosmetic': 'Kosmetyka',
  'dashboard.coinHistory.spendReason': '{category} — {name}',
  'dashboard.coinHistory.spentNotice': 'Wydano {cost} monet na {name}.',
  'dashboard.coinHistory.seo.title': 'Monety grobów',
  'dashboard.coinHistory.seo.description': 'Twój pełny rejestr monet, doładowania i towary umarłych.',
  'dashboard.coinHistory.heading': 'Monety grobów',
  'dashboard.coinHistory.balance': 'saldo',
  'dashboard.coinHistory.buyCoins': 'Kup monety',
  'dashboard.coinHistory.packCoins': '{coins} monet',
  'dashboard.coinHistory.packBonus': ' + {bonus} bonus',
  'dashboard.coinHistory.summoningCheckout': 'Wywoływanie kasy…',
  'dashboard.coinHistory.purchase': 'Zakup',
  'dashboard.coinHistory.spendCoins': 'Wydaj monety',
  'dashboard.coinHistory.insufficientCoins': 'Niewystarczająco monet',
  'dashboard.coinHistory.spending': 'Wydawanie…',
  'dashboard.coinHistory.spendAmount': 'Wydaj {cost}',
  'dashboard.coinHistory.historyTitle': 'Historia',
  'dashboard.coinHistory.tallyingLedger': 'Obliczanie rejestru…',
  'dashboard.coinHistory.tableCaption': 'Historia transakcji monet',
  'dashboard.coinHistory.colReason': 'Powód',
  'dashboard.coinHistory.colAmount': 'Kwota',
  'dashboard.coinHistory.noTransactions': 'Brak transakcji.',

  // ContributionsPage
  'dashboard.contributionsPage.seo.title': 'Mój wkład',
  'dashboard.contributionsPage.seo.description':
    'Lore, które napisałeś, i jego przejście przez spojrzenie moderatorów.',
  'dashboard.contributionsPage.heading': 'Wkład',
  'dashboard.contributionsPage.newContribution': 'Nowy wkład',
  'dashboard.contributionsPage.loading': 'Rozwijamy twoje zwoje…',
  'dashboard.contributionsPage.empty': 'Nie napisałeś jeszcze żadnego lore. Zacznij swój pierwszy wkład.',
  'dashboard.contributionsPage.untitledDraft': 'Nienazwany szkic',
  'dashboard.contributionsPage.moderator': 'Moderator:',
  'dashboard.contributionsPage.entryFallback': 'Wpis',
  'dashboard.contributionsPage.errorNameRequired': 'Każde dzieło potrzebuje nazwy.',
  'dashboard.contributionsPage.modalTitle': 'Nowy wkład',
  'dashboard.contributionsPage.type': 'Typ',
  'dashboard.contributionsPage.titleLabel': 'Tytuł',
  'dashboard.contributionsPage.summaryLabel': 'Streszczenie',
  'dashboard.contributionsPage.saveDraft': 'Zapisz szkic',
  'dashboard.contributionsPage.submitting': 'Wysyłanie…',
  'dashboard.contributionsPage.submitForReview': 'Prześlij do recenzji',
}
